import React, { useState, useEffect } from "react";
import { BsJustify } from "react-icons/bs";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useYearContext } from "../../admin/components/YearContext";

const Empheader = ({ openSidebar }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const { yearSelected, onYearChange } = useYearContext(); // Use context for year

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "employee") {
      navigate("/login");
    }
  }, [navigate]);
  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      const decoded = jwtDecode(token);
      setEmail(decoded.email);

      if (decoded.role !== "employee") {
        navigate("/login");
      }
    }
    fetchUsername();
  }, [token, navigate]);

  const fetchUsername = async () => {
    try {
      const response = await axios.get("https://api.litaxfilers.com/getemployeeheaderusername", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.success) {
        setUsername(response.data.result[0].userName);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    onYearChange(selectedYear);
  };

  return (
    <header className="invoice-header">
      <div className="menu-icon">
        <BsJustify className="icon" onClick={openSidebar} />
      </div>

      <div className="header-left d-flex gap-5 flex-start my-3">
        <select
          className="form-select fs-6"
          value={yearSelected}
          onChange={handleYearChange}
        >
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
        </select>
      </div>

      <div className="header-right ">
        <h6>{username}</h6>
      </div>
    </header>
  );
};

export default Empheader;
